import { User, UserSettings } from "./user";


/**
 * Returns true, iff the given user is the unknownUser.
 */
export function isUserUnknown(user: User): boolean {
	return user.id === -1;
}
